module.exports = __webpack_public_path__ + "img/puzzle.769505d9.svg";